import { nsAccount } from '@/app/i18n/namespaces';
import actionsMerchantUsers from '@/app/modules/users/merchant/api/actionsMerchantUsers';
import Entity from '@/common-utils/components/renders/entity/Entity';
import { Button } from '@/common-utils/components/ui/button';
import { useToast } from '@/common-utils/hooks/use-toast';
import PropTypes from 'prop-types';
import { useEffect } from 'react';


/**
 *
 * @param root0
 * @param root0.token
 * @param root0.setPostImportActionIsLoading
 * @param root0.onClose
 * @returns {JSX} SendResetPasswords
 */
function SendResetPasswords({ token, onClose, setPostImportActionIsLoading }) {

    // Toast
    const { toast } = useToast();

    // API Calls
    const onSuccess = () => {
        onClose();
        toast({
            description: <Entity entity='modal.import.send_reset_password.success' namespace={nsAccount} />,
            variant: 'success'
        });
    };
    const onError = () => {
        onClose();
        toast({
            description: <Entity entity='modal.import.send_reset_password.error' namespace={nsAccount} />,
            variant: 'danger'
        });
    };
    const submitSendResetPasswords = actionsMerchantUsers.resetUsersPassword(onSuccess, onError);

    // Hooks
    useEffect(() => {
        setPostImportActionIsLoading(submitSendResetPasswords.isLoading);
    }, [submitSendResetPasswords.isLoading]);

    return (
        <div className='flex flex-col gap-4'>
            <div>
                <Entity namespace={nsAccount} entity='modal.import.send_reset_password.text_1' />
            </div>
            <div>
                <Entity namespace={nsAccount} entity='modal.import.send_reset_password.text_2' />
            </div>
            <Button
                entity={'modal.import.send_reset_password.button'}
                namespace={nsAccount}
                variant='info'
                className=''
                onClick={() => submitSendResetPasswords.mutate({ token: token })}
                disabled={submitSendResetPasswords.isLoading}
            />
            <Entity namespace={nsAccount} entity='modal.import.send_reset_password.text_3' />
        </div>
    );
}

SendResetPasswords.propTypes = {
    token: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    setPostImportActionIsLoading: PropTypes.func.isRequired
};

export default SendResetPasswords;